import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { ErrorBoundary } from '../components/ErrorBoundary'
import { useContextoStore } from '../store/contextoStore'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { TutorialProvider } from '../features/tutorial/TutorialProvider'
import { ConviteOnboarding } from '../features/tutorial/ConviteOnboarding'

const SIDEBAR_KEY = 'walleon-sidebar-collapsed'

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_KEY) === '1'
  } catch {
    return false
  }
}

export function Shell() {
  const location = useLocation()
  const { selecionados, incluirPropria, principalId, somenteMinhaConta } = useContextoStore()

  const mostrarAviso = selecionados.length > 0 || !incluirPropria
  const nomes = [...(incluirPropria ? ['minha conta'] : []), ...selecionados.map((c) => c.ownerNome)]
  const descricaoContas = nomes.length > 1
    ? `${nomes.slice(0, -1).join(', ')} e ${nomes[nomes.length - 1]}`
    : nomes[0] ?? 'minha conta'
  const nomePrincipal = principalId === null
    ? 'minha conta'
    : selecionados.find((c) => c.ownerUserId === principalId)?.ownerNome ?? 'minha conta'
  const [collapsed, setCollapsed] = useState(readCollapsed)
  const [mobileOpen, setMobileOpen] = useState(false)

  function toggleSidebar() {
    if (window.matchMedia('(max-width: 1023px)').matches) {
      setMobileOpen((v) => !v)
      return
    }
    setCollapsed((v) => {
      try { localStorage.setItem(SIDEBAR_KEY, v ? '0' : '1') } catch { /* storage unavailable */ }
      return !v
    })
  }

  return (
    <TutorialProvider>
    <div className="flex h-full bg-bg">
      <Sidebar collapsed={collapsed} mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />

      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Topbar onToggleSidebar={toggleSidebar} />

        <main className="flex flex-1 flex-col overflow-y-auto">
          {mostrarAviso && (
            <div className="flex flex-wrap items-center gap-2 bg-primary/10 px-6 py-2 text-13 text-primary">
              <i className={selecionados.length + (incluirPropria ? 1 : 0) > 1 ? 'ri-group-line' : 'ri-user-shared-line'} aria-hidden />
              <span>
                Somando {descricaoContas}. Novos lançamentos vão para <strong>{nomePrincipal}</strong>.
              </span>
              <button type="button" onClick={somenteMinhaConta} className="ml-auto underline underline-offset-2 hover:text-white">
                Ver só a minha conta
              </button>
            </div>
          )}
          <div className="flex-1 p-6">
            <ErrorBoundary key={location.pathname}>
              <Outlet />
            </ErrorBoundary>
          </div>
          <footer className="flex flex-wrap items-center justify-between gap-2 border-t border-border/60 px-6 py-5 text-13 text-muted">
            <span>{new Date().getFullYear()} © Walleon.</span>
            <span>Proteja. Organize. Evolua.</span>
          </footer>
        </main>
      </div>
      <ConviteOnboarding />
    </div>
    </TutorialProvider>
  )
}
